// extracted by mini-css-extract-plugin
export default {"root":"Page-module_root-S1bDQ","page":"Page-module_page-TIjka","title":"Page-module_title-ODo4O"};